let ajaxURL = da.ajaxurl;
let ajaxNonce = da.nonce;
let currentUserId = da.user.userid;
let currentUserName = da.user.name;
let currentUserRole = da.user.role;
let loginRedirect = da.login_redirect;  // overview page
let loginPage = da.login_page;
let logoutRedirect = da.logout_redirect;
// let googleRecaptchaSiteKey = da.google_recaptcha_site_key;

let overviewPage = da.overview_page;
let registerPage  = da.registration_page;

let showTOC = da.showTOC;

let mapBoxKey = da.mapbox_api_key;

console.log('showTOC:', showTOC);

// console.log('googleRecaptchaSiteKey', googleRecaptchaSiteKey);

// console.log('overview:', loginRedirect);

const mapPinSvg = `<svg width="22" height="31" viewBox="0 0 22 31" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M11 29.8687C10.7103 29.5353 10.3201 29.078 9.8604 28.5194C8.83891 27.2779 7.47821 25.5401 6.11903 23.5531C4.75837 21.5639 3.40874 19.3387 2.40162 17.1213C1.38993 14.8939 0.75 12.7305 0.75 10.85C0.75 5.27539 5.32304 0.75 11 0.75C16.677 0.75 21.25 5.27539 21.25 10.85C21.25 12.7305 20.6101 14.8939 19.5984 17.1213C18.5913 19.3387 17.2416 21.5639 15.881 23.5531C14.5218 25.5401 13.1611 27.2779 12.1396 28.5194C11.6799 29.078 11.2896 29.5353 11 29.8687Z" fill="#00FF40" stroke="#283C24" stroke-width="1.5"/>
  <circle cx="11" cy="11" r="4" fill="#283C24"/>
</svg>`;



export { ajaxURL, ajaxNonce, currentUserId, currentUserName, currentUserRole,loginRedirect, logoutRedirect, loginPage, overviewPage, registerPage, mapPinSvg, showTOC, mapBoxKey };